<template>
  <path
    d="M3.4 20.4002L20.85 12.9202C21.66 12.5702 21.66 11.4302 20.85 11.0802L3.4 3.6002C2.74 3.3102 2.01 3.8002 2.01 4.5102L2 9.1202C2 9.6202 2.37 10.0502 2.87 10.1102L17 12.0002L2.87 13.8802C2.37 13.9502 2 14.3802 2 14.8802L2.01 19.4902C2.01 20.2002 2.74 20.6902 3.4 20.4002Z"
  />
</template>
